
import dayjs from 'dayjs'
import _ from 'lodash'
import HeaderNavigations from '~/components/molecule/layout/header/HeaderNavigations.vue'
import ButtonEl from '@/components/pub/ButtonEl.vue'
import DeliveryLocationPanel from '~/components/molecule/layout/header/DeliveryLocationPanel.vue'
import DaisoImage from '~/components/common/DaisoImage.vue'
import { commonfunc } from '~/mixin/common'
import CtgrLayer from '@/components/ds/dsa/ctgrLayer.vue'
import { pushSearchGtmData } from '~/utils/gtm'
const { shouldSubmitSearch, shouldSyncSearchTerm } = require('~/utils/searchComposition')

export default {
  name: 'HeaderCmp',
  components: {
    DeliveryLocationPanel,
    HeaderNavigations,
    DaisoImage,
    CtgrLayer: () => import('@/components/ds/dsa/ctgrLayer.vue'),
    BrandCategory: () => import('@/components/ds/dsa/BrandCategory.vue'),
    ButtonEl,
  },
  mixins: [commonfunc],
  props: {
    logo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageName: {
      type: String,
      default: ''
    },
    tabActive: {
      type: String,
      default: 'tab01'
    },
    backBtn: {
      type: Boolean,
      default: false
    },
    searchBtn: {
      type: Boolean,
      default: false
    },
    searchArea: {
      type: Boolean,
      default: false
    },
    basketBtn: {
      type: Boolean,
      default: false
    },
    qrBtn: {
      type: Boolean,
      default: false
    },
    mapBtn: {
      type: Boolean,
      default: false
    },
    closeBtn: {
      type: Boolean,
      default: false
    },
    moreBtn: {
      type: Boolean,
      default: false
    },
    enroBtn: {
      type: Boolean,
      default: false
    },
    homeBtn: {
      type: Boolean,
      default: false
    },
    setBtn: {
      type: Boolean,
      default: false
    },
    alarmBtn: {
      type: Boolean,
      default: false
    },
    stepLine: {
      type: Boolean,
      default: false
    },
    perVal: {
      type: String,
      default: ''
    },
    headerWhite: {
      type: String,
      default: ''
    },
    searchTerm: {
      type: String,
      default: ''
    },
    currentUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentMall: 'home',
      navigationsData: [
        {
          id: 'home',
          label: '다이소',
          path: '/ds',
        },
        // {
        //   id: 'store',
        //   label: '매장',
        //   path: '/ms/msb/SCR_MSB_0001',
        // }
      ],
      // 공통 주소 설정
      commonUrls: {
        production: {
          pickup: '/ds/pickupOrder/C232',
          bulk: '/ds/bulkOrder/C231',
          today: '/ds/quickOrder/C234'
        },
        development: {
          pickup: '/ds/pickupOrder/C119',
          bulk: '/ds/bulkOrder/C116',
          today: '/ds/quickOrder/C118'
        }
      },
      dvyAddr: '',
      baseTime: '10월 06일 00:00',
      cartNum: 0,
      activeTab: 'tab1', // 검색 순위 팝업 내부 탭
      swiperOpt: { // GNB 스와이퍼
        slidesPerView: 'auto',
        loop: false,
        lazy: true,
        FreeMode: true
      },
      gnbList: [],
      gnbActive: 0,
      input1: '',
      bubbleShow: true,
      visibleAd: false, // 배송지 설정 팝업
      visibleRank: false, // 인기 검색어 팝업
      visibleRankTool: false, // 인기 검색어 기준 툴팁
      active: '1', // 탭 index(활성화)
      tabsDataSub: [ // 탭 data
        {
          id: '1',
          title: '1~10위',
          name: '1'
        },
        {
          id: '2',
          title: '11~20위',
          name: '2'
        }
      ],
      searchRankList: [], // 검색 순위 리스트
      rankingList: [],
      rankError: false, // 랭크 데이터 못불러올 때
      rankingSwiperOpt: { // 검색 순위 스와이퍼
        slidesPerView: 1,
        loop: true,
        direction: 'vertical',
        allowTouchMove: false,
        autoplay: {
          delay: 3000,
          autoplayDisableOnInteraction: false
        }
      },
      popRankSwiperOpt: {
        auto: false,
        loop: false,
        navigation: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="blind">' + (index + 1) + '</span></button>'
          },
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      recentlySearchTerms: [],
      RecentShowMoreLeft: false,
      RecentShowMoreRight: true,
      autoCompleteList: [],
      placeholders: [],
      placeholder: '',
      emptyLink: '/',
      searchInput: this.searchTerm, // 검색 input
      isSearchComposing: false,
      isSearchEditing: false,
      isSearchSubmitting: false,
      lastSubmittedSearchTerm: this.searchTerm,
      searchPopRecent: false, // 최근 검색어 팝업
      searchPopAuto: false, // 검색 자동완성 팝업
      swiperTotalWidth: 0, // 스와이퍼 총 넓이
      swipeWrapWidth: 0, // 스와이퍼 제어 대상 부모 넓이
      isDestroy: false, // 스와이퍼 작동 중지 여부

      fullCateVisible: false, // 카테고리 목록 mouseover 여부
      fullCateBrandVisible: false,
      isCategoryOpen: false, // 카테고리
      isBrandCategoryOpen: false,
      loginNkNm: '',
      // 23.12.05 랭킹리스트 변경 추가
      currentIndex: 0,
      itemHeight: 20,
      trendInterval: null,
      brandRedirectList: [],
      recmKeywordList: [],
      autoKeywordIndex: -1,
      currentPlaceholderKeyword: '',
      activeChip: 'all',
      // rankingChipsList 는 3월에 뷰티몰 오픈 시 다시 주석해제.(@chococho1 이 할거임)
      // rankingChipsList: [
      //   {
      //     id: 'all',
      //     title: '전체'
      //   },
      //   {
      //     id: 'bt',
      //     title: '뷰티&헬스'
      //   },
      //   {
      //     id: 'fashion',
      //     title: '패션'
      //   },
      //   {
      //     id: 'store',
      //     title: '매장'
      //   }
      // ]
    }
  },
  // head () {
  //   return {
  //     meta: [...this.setGroobeeMeta()],
  //     script: [...this.setGroobeeScript()],
  //     __dangerouslyDisableSanitizers: ['script'] // 그루비처리시 필요
  //   }
  // },
  computed: {
    swiper () {
      return this.$refs.reactiveSwiper.swiper
    },
    isLogined () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      return !!mbMngNo
    },
    // 현재 환경에 맞는 주소 반환 (PC 전용)
    currentDeliveryUrls () {
      const env = process.env.WEB_BASE_URL || 'local'

      // 운영/QA 환경은 production, 나머지는 development
      const isProduction = ['prd', 'qa'].includes(env)
      return isProduction ? this.commonUrls.production : this.commonUrls.development
    },
  },
  watch: {
    searchTerm (value) {
      this.syncSearchInputFromExternal(value)
    },
    loginNkNm () {
      this.makePlaceholderByRanking()
    },
    placeholders () {
      if (this.placeholders.length > 0) {
        const index = Math.floor(Math.random() * this.placeholders.length)
        const name = this.loginNkNm === '' ? '고객' : this.loginNkNm
        const keyword = this.placeholders[index].cmmnCdNm
        this.placeholder = name + '님, ' + keyword + ' 찾으세요?'
        this.emptyLink = this.placeholders[index].scdUserFd
        this.currentPlaceholderKeyword = keyword
      } else {
        this.placeholder = ''
        this.currentPlaceholderKeyword = ''
      }
    },

    isLogined (value) {
      this.getCartNum()
      this.loginNkNm = this.unescape(this.$store.getters['session/getMbEfnm'])
      /*
      await this.getBaseDdvyAddr()
      if (value && !this.$route.params.openTransfPopup) {
        console.log('watch에서 배송지설정안내', this.$route)
        this.showAdPopover()
      }
      */
    },
    $route: {
      immediate: true,
      handler () {
        this.syncSearchInputFromExternal(this.searchTerm)
        this.getCartNum()
        this.loginNkNm = this.unescape(this.$store.getters['session/getMbEfnm'])
        this.setGnbActive()
      }
    }
  },
  created () {
    this.$nuxt.$on('getCartNum', this.getCartNum)
  },
  async mounted () {
    this.currentMall = !this.isNotEmpty(localStorage.getItem('currentMall')) ? JSON.parse(localStorage.getItem('currentMall')) : 'home'
    if (sessionStorage.getItem('hasVisited') === null) {
      sessionStorage.setItem('hasVisited', true) // 첫방문 여부
    }
    // 전시 코너정보 조회
    await this.loadGnbDsCnrList()
    this.setGnbActive()
    // 최근검색어
    this.initRecentlyWord()
    // 추천키워드
    this.recmKeywordList = await this.selRcmKeywd()
    // 인기 검색어 정보 조회
    await this.loadTopSearchKeywords()
    // 장바구니 갯수
    await this.getCartNum()
    // 검색창 플레이스홀더 조회
    await this.getPlaceholders()
    this.swiperWidth()

    // 로그인이 되어있고, referer가 로그인화면이라면 5초간 팝업 노출
    if (this.isLogined && !this.$route.params.openTransfPopup) {
      this.showAdPopover()
    }
    window.addEventListener('keydown', this.getAutoSearchTerm)
  },
  beforeDestroy () {
    clearInterval(this.trendInterval)
    window.removeEventListener('keydown', this.getAutoSearchTerm)
  },
  methods: {
    isNewPath (path) {
      const newPaths = [
        '/ds/diy2/C131', // 뷰티
        '/ds/diy2/C132', // 건강식품
        '/ds/diy2/C245', // 운영 뷰티
        '/ds/diy2/C246' // 운영 건강식품
      ]
      return newPaths.includes(path)
    },
    moveMall (item) {
      localStorage.setItem('currentMall', JSON.stringify(item.id))
      this.currentMall = item.id
      this.$router.push(item.path)
    },
    getRankStatus (item) {
      if (item.new) {
        return 'new'
      } else if (item.up) {
        return 'up'
      } else if (item.down) {
        return 'down'
      } else {
        return 'same'
      }
    },
    recentlyMore (direction) {
      const scrollWrapper = this.$refs.recentlyKewordList
      if (!scrollWrapper) {
        return
      }

      const conWidth = scrollWrapper.clientWidth
      // const scWidth = scrollWrapper.scrollWidth + 80
      const scWidth = scrollWrapper.scrollWidth
      const currentLeft = scrollWrapper.scrollLeft

      if (direction === 'right') {
        scrollWrapper.scrollTo({
          left: currentLeft + conWidth,
        })
      } else {
        scrollWrapper.scrollTo({
          left: currentLeft - conWidth,
        })
      }

      // 버튼 상태 갱신
      this.$nextTick(() => {
        const scrollLeft = scrollWrapper.scrollLeft
        const newScWidth = scrollWrapper.scrollWidth
        const newConWidth = scrollWrapper.clientWidth
        this.RecentShowMoreLeft = scrollLeft > 0
        this.RecentShowMoreRight = Math.round(scrollLeft + newConWidth) < Math.round(newScWidth)
      })
    },
    async getBaseDdvyAddr () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']

      if (this.isNotEmpty(mbMngNo)) {
        const param = { mbMngNo }
        await this.$AxiosBuilder
          .data(param)
          .build()
          .post('/or/orc/selBassDvya')
          .then((res) => {
            console.log('/or/orc/selBassDvya ::: ', res)
            if (res.data.data.addrBassEaddr) {
              let dvyAddr = this.isNotEmpty(res.data.data.addrZip) ? '(' + res.data.data.addrZip + ')' : ''
              dvyAddr = dvyAddr + res.data.data.addrBassEaddr + ' ' + res.data.data.dtlEaddr
              this.dvyAddr = dvyAddr
            } else {
              this.dvyAddr = ''
            }
          }).catch((e) => {
            console.error('e', e)
          })
      } else {
        this.dvyAddr = ''
      }
      console.log('this.dvyAddr', this.dvyAddr)
    },
    showAdPopover () {
      setTimeout(() => {
        this.visibleAd = true
        setTimeout(() => {
          this.visibleAd = false
        }, 5000)
      }, 2000)
    },
    initRecentlyWord () {
      let recentlySearchTerms
      this.recentlySearchMoved = false
      if (localStorage.getItem('recentlySearchTerms') !== null) {
        recentlySearchTerms = JSON.parse(localStorage.getItem('recentlySearchTerms'))
      } else {
        recentlySearchTerms = []
      }
      this.recentlySearchTerms = recentlySearchTerms
    },
    delRecentlyAll () {
      this.recentlySearchTerms = []
      localStorage.setItem('recentlySearchTerms', JSON.stringify(this.recentlySearchTerms))
    },
    delRecently (idx) {
      if (this.isNotEmpty(this.recentlySearchTerms[idx])) {
        this.recentlySearchTerms.splice(idx, 1)
      }
      localStorage.setItem('recentlySearchTerms', JSON.stringify(this.recentlySearchTerms))
      this.recentlyMore()
    },
    async getPlaceholders () {
      const name = this.loginNkNm === '' ? '고객' : this.loginNkNm
      if (sessionStorage.getItem('hasVisited') === 'true') {
        console.log(typeof sessionStorage.getItem('hasVisited'))
        const resData = await this.$AxiosBuilder
          .data()
          .build()
          .post('/ds/exh/selPlaceholder')
          .then((res) => {
            sessionStorage.setItem('hasVisited', false)
            return res.data.data
          })
        this.placeholders = resData
      } else {
        this.makePlaceholderByRanking()
      }
    },
    makePlaceholderByRanking () {
      const name = this.loginNkNm === '' ? '고객' : this.loginNkNm
      let currentIndex = sessionStorage.getItem('popularKeywordIndex')

      if (currentIndex === null || isNaN(parseInt(currentIndex))) {
        currentIndex = 0
      } else {
        currentIndex = parseInt(currentIndex)
      }

      // Ensure currentIndex is within 0-9 range
      if (currentIndex >= 10) { // Limit to maximum 9 (i.e., reset at 10)
        currentIndex = 0
      }

      const keyword = this.rankingList[currentIndex]?.name ?? ''
      this.placeholder = `${name}님, ${keyword} 찾으세요?`
      this.currentPlaceholderKeyword = keyword

      // Calculate the next index, cycling within 0-9
      const nextIndex = (currentIndex + 1) % 10
      sessionStorage.setItem('popularKeywordIndex', nextIndex)
    },
    setSearchTerm (keyword) {
      this.totalSearch(keyword)
    },
    syncSearchInputFromExternal (value) {
      const incomingTerm = typeof value === 'string' ? value : ''
      const routeSearchTerm = String(this.$route.query.searchTerm ?? '')

      if (!shouldSyncSearchTerm({
        isComposing: this.isSearchComposing,
        isEditing: this.isSearchEditing,
        isSubmitting: this.isSearchSubmitting,
        incomingTerm,
        submittedTerm: this.lastSubmittedSearchTerm,
        routeSearchTerm,
      })) {
        return
      }

      this.searchInput = incomingTerm
      if (this.isSearchSubmitting && incomingTerm === this.lastSubmittedSearchTerm) {
        this.isSearchSubmitting = false
      }
      if (this.searchInput === '') {
        this.searchPopAuto = false
        this.searchPopRecent = false
      }
    },
    handleSearchFocus () {
      this.getAutoComplete(this.searchInput)
    },
    handleSearchBlur (event) {
      this.isSearchComposing = false
      this.searchPopup(event, 'blur')
    },
    handleSearchNativeInput (event) {
      const value = event?.target?.value
      if (typeof value !== 'string') {
        return
      }

      this.searchInput = value
      this.isSearchEditing = true
      if (!this.isSearchComposing) {
        this.debounceAutoComplete(value)
      }
    },
    handleSearchInput (value) {
      this.isSearchEditing = true
      if (!this.isSearchComposing) {
        this.debounceAutoComplete(value)
      }
    },
    handleSearchCompositionStart () {
      this.isSearchComposing = true
    },
    handleSearchCompositionEnd (event) {
      this.isSearchComposing = false
      this.isSearchEditing = true
      this.debounceAutoComplete(event?.target?.value ?? this.searchInput)
    },
    handleSearchEnter (event) {
      if (!shouldSubmitSearch(event, this.isSearchComposing)) {
        return
      }

      this.totalSearch()
    },
    handleSearchClick () {
      this.totalSearch()
    },
    debounceAutoComplete: _.debounce(function (value) { this.getAutoComplete(value) }, 50),
    getAutoComplete (value) {
      if (value !== '') {
        const params = { searchTerm: value, mallId: 'MALL_MAIN' }
        this.$AxiosBuilder
          .params(params)
          .baseURL(process.env.API_SSN_BASE_URL2)
          .build()
          .get('/autoSearch')
          .then((res) => {
            if (this.isSearchSubmitting || !this.isSearchEditing) {
              return
            }
            if (res.data.returnCode >= 0) {
              this.brandRedirectList = res.data.resultSet.result[0].resultDocuments
              let autoKeyword = res.data.resultSet.result[1].resultDocuments
              if (res.data.resultSet.result[1].totalSize === 0) {
                autoKeyword = res.data.resultSet.result[2].resultDocuments
              }
              this.autoCompleteList = [
                ..._.chain(autoKeyword)
                  .map(item => ({
                    keyword: this.removeTag(item.keyword),
                    html: this.parseEmToSpan(item.keyword),
                  }))
                  .value(),
              ]
              this.searchPopup()
            }
          })
      } else {
        this.autoCompleteList = []
        this.brandRedirectList = []
        this.searchPopup()
      }
    },
    parseEmToSpan (keyword) {
      let value = keyword
      value = value.replaceAll('<em>', '<span class="same">')
      value = value.replaceAll('</em>', '</span>')
      return value
    },
    removeTag (keyword) {
      let value = keyword
      value = value.replaceAll('<em>', '')
      value = value.replaceAll('</em>', '')
      return value
    },
    async totalSearch (keyword) {
      this.autoKeywordIndex = -1
      let term = ''

      if (keyword && typeof keyword === 'string') {
        term = keyword
      } else {
        term = this.searchInput
      }

      if (term) {
        term = term.trim()
      }

      if (!this.isNotEmpty(term)) {
        if (this.isNotEmpty(this.currentPlaceholderKeyword)) {
          term = this.currentPlaceholderKeyword
        } else {
          return false
        }
      }

      this.searchInput = term
      this.lastSubmittedSearchTerm = term
      this.isSearchEditing = false
      this.isSearchSubmitting = true

      // 최근 검색어 localStorage처리
      this.recentlySearchTerms.forEach((recently, recentlyIdx) => {
        if (recently.keyword === term) {
          this.recentlySearchTerms.splice(recentlyIdx, 1)
        }
      })

      const recentlyItem = {
        keyword: term,
        date: dayjs().format('YYYY.MM.DD')
      }
      if (this.recentlySearchTerms.length >= 10) {
        this.recentlySearchTerms.pop()
      }
      this.recentlySearchTerms.unshift(recentlyItem)
      localStorage.setItem('recentlySearchTerms', JSON.stringify(this.recentlySearchTerms))

      this.searchPopRecent = false
      this.searchPopAuto = false

      const srchCdList = await this.selCmmnCd(['CD_00542'])
      for (const list of srchCdList) {
        if (list.cmmnCd === '01' &&
            (term.includes('리들샷') || term === '1049275' || term === '1049276')) {
          return this.$router.push(list.fstUserFd)
        }
        if (list.cmmnCd === '02' && term.includes('알림신청')) {
          return this.$router.push(list.fstUserFd)
        }
        if (list.cmmnCd === '03' && term.includes('신상클럽')) {
          return this.$router.push(list.fstUserFd)
        }
        if (list.cmmnCd === '05' && term.includes('오픈런')) {
          return this.$router.push(list.fstUserFd)
        }
      }

      // this.$blux.customEventSend('search', term) // 검색시 BLUX 검색 데이터 전달
      pushSearchGtmData(term) // 검색시 GTM DataLayer Push 실행
      sessionStorage.setItem('filterCheck', [])
      sessionStorage.setItem('prodSortCheck', '')
      this.$router.push({
        path: '/ds/dst/SCR_DST_0015',
        query: {
          searchTerm: term
        }
      })
    },
    searchPopup (e, type) { // 검색 팝업 제어
      switch (type) {
        case 'blur':
          // 검색영역 제외한 부분 클릭 시
          if (e.target.closest('.search-wrap') === null) {
            this.searchPopRecent = false
            this.searchPopAuto = false
            // backTab 인풋 영역 focusout
          } else if (e.relatedTarget !== null && e.relatedTarget.classList.contains('logo')) {
            this.searchPopAuto = false
            this.searchPopRecent = false
          }
          break
        case 'popBlur':
          // 팝업 내 마지막 요소 focusout
          if (e.target.classList.contains('focus-last')) {
            this.searchPopAuto = false
            this.searchPopRecent = false
          }
          break
        default:
          // 최근 검색어, 자동완성 팝업 상태 제어 (예시)
          this.recentlyMore()
          if (this.autoCompleteList.length === 0) {
            this.searchPopRecent = true
            this.searchPopAuto = false
            this.$nextTick(() => {
              this.$refs.recentlyKewordList?.scrollTo(0, 0)
              this.RecentShowMoreLeft = false
              if (this.$refs?.recentlyKewordList?.clientWidth >= this.$refs?.recentlyKewordList?.scrollWidth) {
                this.RecentShowMoreRight = false
              } else {
                this.RecentShowMoreRight = true
              }
            })
          } else {
            this.searchPopAuto = true
            this.searchPopRecent = false
          }
          break
      }
    },
    onClickWindow (e) {
      this.searchPopup(e, 'blur')
    },
    /**
     * @description 전시 코너목록 조회
     * @params :
     *  exhCnrId - 코너 ID
     */
    async loadGnbDsCnrList () {
      const cnrList = await this.$AxiosBuilderPostCache
        .data({ exhCnrId: 'C1' })
        .build(24 * 60 * 60 * 1000) // 24시간 캐시
        .post('/ds/cnr/selCnrList')
        .then((res) => {
          const data = res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
          window.localStorage.setItem('corner-list', JSON.stringify(data))
          return data.map((item) => {
            if (item.pcomImgAtchFileUrl) {
              return {
                id: item.exhCnrId,
                name: this.unescape(item.iconRplcTextNm),
                nameColor: item.exhCnrNmColorCd,
                img: item.pcomImgAtchFileUrl,
                alt: item.pcomImgOrglFileNm,
                link: item.pcScrUrl,
                linkUrl: item.pcScrUrl,
                subExhCnrList: item.subExhCnrList?.map((item) => {
                  return {
                    id: item.exhCnrId,
                    name: this.unescape(item.exhCnrNm),
                    linkUrl: item.pcScrUrl,
                    imgUrl: item.pcomImgAtchFileUrl,
                  }
                })
              }
            } else {
              return {
                id: item.exhCnrId,
                name: this.unescape(item.iconRplcTextNm),
                nameColor: item.exhCnrNmColorCd,
                link: item.pcScrUrl,
                linkUrl: item.pcScrUrl,
                subExhCnrList: item.subExhCnrList?.map((item) => {
                  return {
                    id: item.exhCnrId,
                    name: this.unescape(item.exhCnrNm),
                    linkUrl: item.pcScrUrl,
                    imgUrl: item.pcomImgAtchFileUrl,
                  }
                })
              }
            }
          })
        })
      this.gnbList = cnrList
      this.$store.commit('local/setGnbMenuList', JSON.parse(JSON.stringify(cnrList)))
      this.setGnbActive()
    },
    setGnbActive () {
      const currentPath = this.$route.path
      console.log('setGnbActive currentPath:', currentPath)
      console.log('gnbList:', this.gnbList.map(item => item.link))
      this.gnbActive = this.gnbList.findIndex((item) => {
        if (item.link === '/ds') {
          return currentPath === '/ds'
        } else {
          // /ds/rank로 시작하는 모든 경로는 랭킹 메뉴로 매칭
          if (item.link.startsWith('/ds/rank') && currentPath.startsWith('/ds/rank')) {
            return true
          }
          // /ds/newShorts/{id}로 시작하는 경로는 해당 카테고리의 모든 하위 경로 매칭
          if (item.link.startsWith('/ds/newShort') && currentPath.startsWith('/ds/newShort')) {
            return true
          }
          if (item.link.startsWith('/ds/curation') && currentPath.startsWith('/ds/curation')) {
            return true
          }
          // 전체 경로 비교로 정확한 매칭
          return currentPath === item.link || currentPath.startsWith(item.link + '/')
        }
      })
      console.log('gnbActive:', this.gnbActive)
    },
    /**
     * @description 인기 검색어 목록 조회
     * @params :
     *  rank - 검색어 순위
     */
    async loadTopSearchKeywords () {
      this.baseTime = ''
      const data = await this.$AxiosBuilder
        .params({ rank: 20, mallId: 'MALL_MAIN' })
        .baseURL(process.env.API_SSN_BASE_URL2)
        .build()
        .get('/trendSearch')
        .then((res) => {
          return res.data.resultSet.result[0]
        })
        .catch((e) => {
          console.error(e)
        })
      if (data) {
        this.searchRankList = []
        const resultDocuments = data.resultDocuments.map(item => ({
          rank: item.rank,
          name: item.keyword,
          up: parseInt(item.PRERANK) > 0 && parseInt(item.RANKING_GAP) < 0,
          // down: Number(item.preRank) > 0 && (Number(item.preRank) - Number(item.rank)) < 0 ? (Number(item.rank) - Number(item.preRank)).toString() : '',
          new: parseInt(item.PRERANK) === 0 && parseInt(item.RANKING_GAP) > 0
        }))
        console.log(resultDocuments)
        this.rankingList = JSON.parse(JSON.stringify(resultDocuments))

        for (let i = 0; i < resultDocuments.length; i += 10) {
          this.searchRankList.push(resultDocuments.slice(i, i + 10))
        }
      } else {
        this.rankError = true
        console.log('trendSearch error')
      }
    },
    // == gnb swipe
    swiperWidth () { // 슬라이드 총 넓이
      const swiperItem = this.$refs?.reactiveSwiper?.$el?.querySelectorAll('.swiper-slide')

      if (this.isEmpty(swiperItem)) {
        return
      }

      let sum = 0
      swiperItem.forEach((item) => {
        sum += item.clientWidth
      })
      this.swiperTotalWidth = sum
    },
    cateActive () {
      if (this.fullCateVisible === false) {
        this.fullCateVisible = true
        this.isCategoryOpen = true
      }
    },
    cateCloseBtn (e, refBtnName, refPanelName) {
      const btn = this.$refs[refBtnName]
      const panel = this.$refs[refPanelName]
      if (!btn || !panel) {
        return false
      }
      const to = e.relatedTarget
      if (to && (btn.contains(to) || panel.contains(to))) {
        return
      }
      if (refBtnName === 'categoryBtn') {
        this.fullCateVisible = false
        this.isCategoryOpen = false
      } else {
        this.fullCateBrandVisible = false
        this.isBrandCategoryOpen = false
      }
    },
    cateActiveBrand () {
      if (this.fullCateBrandVisible === false) {
        this.fullCateBrandVisible = true
        this.isBrandCategoryOpen = true
      }
    },
    signout () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (mbMngNo !== null && mbMngNo !== undefined && mbMngNo !== '') {
        // 로그아웃 처리 후 메인 페이지로 이동
        this.$AxiosBuilder
          .data(this.$store.getters['session/getMb'])
          .build()
          .post('/mb/mbb/logout')
          .then((res) => {
            this.$createToast('로그아웃 되었습니다.')

            console.log(res)
            this.$store.commit('session/setMember', {}) // 세션객체 초기화
            this.$airbridge.sendSignOut()
            this.$router.push({ path: '/' })
          })
      } else {
        this.goSignin()
      }
    },
    goSignin () {
      this.visibleAd = false
      this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route } })
    },
    openTransf () {
      this.visibleAd = false
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        const targetObj = Object.assign({}, this.$route)
        targetObj.params.openTransfPopup = true
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: targetObj } })
      } else {
        this.$nuxt.$emit('openTransfPopup', true)
      }
    },
    moveLink (link) {
      this.$router.push(link)
    },
    goZzimPage () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: '/pd/pdm/SCR_PDM_0011?currentTab=1' } })
      } else if (this.$route.path === '/pd/pdm/SCR_PDM_0011?currentTab=1') {
        this.$router.go(0)
      } else {
        this.$router.push({ path: '/pd/pdm/SCR_PDM_0011?currentTab=1' })
      }
    },
    goMyPage () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        console.log('로그인 해야됨', mbMngNo)
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: '/mb/mbc/SCR_MBC_0110A' } })
      } else if (this.$route.path === '/mb/mbc/SCR_MBC_0110A') {
        console.log('같은경로임', this.$route.path, this.$router.currentRoute, this.$route)
        this.$router.go(this.$router.currentRoute)
      } else {
        console.log('마이페이지로 이동')
        this.$router.push({ path: '/mb/mbc/SCR_MBC_0110A' })
      }
    },
    goCart () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        console.log('로그인 해야됨', mbMngNo)
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: '/or/orc/SCR_ORC_0001' } })
      } else if (this.$route.path === '/or/orc/SCR_ORC_0001') {
        console.log('같은경로임', this.$route.path, this.$router.currentRoute, this.$route)
        this.$router.go(this.$router.currentRoute)
      } else {
        console.log('장바구니로 이동')
        this.$router.push({ path: '/or/orc/SCR_ORC_0001' })
      }
    },
    async getCartNum () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (this.isNotEmpty(mbMngNo)) {
        const payload = {
          mbMngNo: this.$store.getters['session/getMbMngNo']
        }
        await this.$AxiosBuilder
          .data(payload)
          .build()
          .post('/or/api/selSpbkCont')
          .then((res) => {
            if (res.data !== null && res.data.success) {
              this.cartNum = res.data.data?.spbkCont
            }
          }).catch((e) => {
            console.error('e', e)
          })
      } else {
        this.cartNum = 0
      }
    },
    goOrderTransp () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: '/or/ORB/SCR_ORB_0001' } })
      } else if (this.$route.path === '/or/ORB/SCR_ORB_0001') {
        this.$router.go(this.$router.currentRoute)
      } else {
        this.$router.push({ path: '/or/ORB/SCR_ORB_0001' })
      }
    },
    goMembership () {
      if (this.$route.path === '/ms/msb/SCR_MSB_0001') {
        this.$router.go(this.$router.currentRoute)
      } else {
        this.$router.push({ path: '/ms/msb/SCR_MSB_0001' })
      }
    },
    closeCate () {
      this.fullCateVisible = false
    },
    // 23.12.05 랭킹리스트 변경 추가
    calcTranslateY (index) {
      const translateY = index * this.itemHeight
      return translateY
    },
    resetFilterCheck () {
      console.log('헤더 resetFilterCheck !!!!')
      sessionStorage.removeItem('lgCtgrData')
      sessionStorage.setItem('preventSaveLgCtgrData', 'true')
      sessionStorage.setItem('filterCheck', [])
      sessionStorage.setItem('prodSortCheck', '')
    },
    goRedirectBrand (redirectUrl) {
      sessionStorage.setItem('filterCheck', [])
      sessionStorage.setItem('preFilterCheck', [])
      this.$router.push({ path: redirectUrl })
    },
    getAutoSearchTerm (e) {
      if (!this.searchPopAuto) {
        return
      }
      if (e.keyCode === 38) { // 화살표키 위방향
        this.autoKeywordIndex = (this.autoKeywordIndex - 1) % this.autoCompleteList.length
        this.searchInput = this.autoCompleteList[this.autoKeywordIndex].keyword
      } else if (e.keyCode === 40) { // 화살표키 아래방향
        this.autoKeywordIndex = (this.autoKeywordIndex + 1) % this.autoCompleteList.length
        this.searchInput = this.autoCompleteList[this.autoKeywordIndex].keyword
      }
    },
    async selRcmKeywd () {
      const paramdata = {
        mallSeCd: '01' // 몰구분코드 (생활용품몰:01)
      }

      try {
        const res = await this.$AxiosBuilder
          .data(paramdata)
          .build()
          .post('/ds/dsl/selRcmKeywd')

        const resList = res.data.data
        return resList.map(item => ({
          title: item.rcmKeywdNm,
          src: item.imgUrl
        }))
      } catch (err) {
        console.log(err)
        return []
      }
    }
  }
}
